import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useState, useEffect } from "react";
import { Container, Row, Col, Table, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import { faLayerGroup, faSpinner, faUsers } from "@fortawesome/free-solid-svg-icons";
import "./schedules.css";
import moment from "moment";
import "moment/locale/pl";
import ActionBtns from "./ActionBtns";
import { daysLater } from "../../commonData";
import ScheduleFilters from "./ScheduleFilters";
import SimpleTextModal from "../../components/modals/SimpleTextModal";
import SubstituteInstructor from "../../components/SubstituteInstructor";
import { useLocation } from "react-router-dom";
moment.locale("pl"); // pl

const Schedule = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData, showView } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [originalList, setOriginalList] = useState(null);
    const initDates = { startDate: new Date(), endDate: daysLater(new Date(), 6) };
    const [filterDates, setFilterDates] = useState(null);
    const [selectedInstructor, setSelectedInstructor] = useState(null);
    const [selectedClassLvl, setSelectedClassLvl] = useState(null);
    const [daysDifference, setDaysDifference] = useState(7);
    const [showClassDetailsModal, setShowClassDetailsModal] = useState(false);
    const [date, setDate] = useState({ startDate: null, endDate: null });
    const [permissions, setPermissions] = useState(null);
    let location = useLocation();

    const getSchedule = async (startDate, endDate) => {
        const res = await postMethod("/get-schedule", { startDate: startDate, endDate: endDate });
        if (checkServerData(res)) {
            const schedule = res.data.list;
            console.log(schedule);
            setPermissions(res.data.permissions);
            setDaysDifference(res.data.dateDifference);
            const scheduleList = [];
            let now = new Date(startDate);
            for (let i = 0; i <= res.data.dateDifference; i++) {
                const currentDay = moment(now).format("YYYY-MM-DD");
                scheduleList.push({
                    dateName: `${moment(now).format("LL")} (${moment(now).format("dddd")})`,
                    classes: schedule.filter((e) => moment(e.class_start_time).format("YYYY-MM-DD") === currentDay),
                });
                now = daysLater(now, 1);
            }

            const fnClassStartTime = (a, b) => {
                if (new Date(a.class_start_time) > new Date(b.class_start_time)) return 1;
                else return -1;
            };

            scheduleList.forEach((e) => {
                e.classes = e.classes.sort(fnClassStartTime);
            });

            setOriginalList(scheduleList);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (filterDates) {
            setLoading(true);
            setTimeout(() => {
                getSchedule(filterDates.startDate, filterDates.endDate);
            }, 150);
        }
        // eslint-disable-next-line
    }, [filterDates]);

    const applyFilters = () => {
        const filterByInstructor = (c) => !selectedInstructor || (parseInt(c.instructor_id) === selectedInstructor && !c.instructor_label); //filter only instructors that are not substitute
        const filterByClassLevel = (c) => !selectedClassLvl || c.class_level_code === selectedClassLvl;

        const filteredList = originalList
            .map((e) => ({
                ...e,
                classes: e.classes.filter((c) => filterByInstructor(c) && filterByClassLevel(c)),
            }))
            .filter((e) => !date.startDate || !date.endDate || e.classes.length > 0);

        setList(filteredList);
    };

    useEffect(() => {
        if (originalList) applyFilters();
        // eslint-disable-next-line
    }, [selectedClassLvl, selectedInstructor, originalList]);

    useEffect(() => {
        if (list) {
            if (loading) setLoading(false);
        }

        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        /* localStorage.removeItem("startDate");
        localStorage.removeItem("endDate"); */
        if (localStorage.getItem("startDate") && localStorage.getItem("endDate") && location.pathname !== "/") {
            setFilterDates({ startDate: localStorage.getItem("startDate"), endDate: localStorage.getItem("endDate") });
        } else setFilterDates(initDates);

        //console.log(location);
        // eslint-disable-next-line
    }, []);

    const checkIfListIsEmpty = (l) => {
        let listLength = 0;
        l.forEach((e) => {
            listLength += e.classes.length;
        });
        return listLength > 0 ? false : true;
    };

    return (
        <Fragment>
            {filterDates && (
                <Container fluid="lg">
                    <ScheduleFilters
                        setFilterDates={setFilterDates}
                        filterDates={filterDates}
                        selectedInstructor={selectedInstructor}
                        setSelectedInstructor={setSelectedInstructor}
                        selectedClassLvl={selectedClassLvl}
                        setSelectedClassLvl={setSelectedClassLvl}
                        initDates={initDates}
                        daysDifference={daysDifference}
                        date={date}
                        setDate={setDate}
                        permissions={permissions}
                    />
                    <Row>
                        {loading ? (
                            <Row>
                                <Col className="my-5 text-center">
                                    <p className="h5">
                                        {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                    </p>
                                </Col>
                            </Row>
                        ) : !originalList ? (
                            <p className="text-center mt-4">
                                <Alert variant="danger">{t("error.cannotLoadSchedule")}</Alert>
                            </p>
                        ) : (
                            <Fragment>
                                {checkIfListIsEmpty(list) ? (
                                    <Col xs={12} className="text-center">
                                        <p className="fs-6 mt-3">{t("notFound")}</p>
                                    </Col>
                                ) : (
                                    <Col xs={12} lg={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
                                        {list.map((e, i) => (
                                            <Fragment key={i}>
                                                <Row>
                                                    <Col xs={12} className="py-3" id="dayContainer">
                                                        <Row>
                                                            <Col>
                                                                <p className="px-1 mb-2">{e.dateName}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            {e.classes.length === 0 ? (
                                                                <Col>
                                                                    <p className="no-classes px-1">{t("schedule.noClasses")}</p>
                                                                </Col>
                                                            ) : (
                                                                <Col className="px-0">
                                                                    <Table borderless size="sm" className="mb-0">
                                                                        <tbody>
                                                                            {e.classes.map((c, j) => (
                                                                                <Fragment key={j}>
                                                                                    <tr
                                                                                        className={`${c.class_status_code === "CANCELLED" && "class-cancelled"} class-lvl-bg-${
                                                                                            c.class_level_colour ? c.class_level_colour : "white"
                                                                                        }`}
                                                                                    >
                                                                                        <td className="bold hour-td align-bottom">{moment(c.class_start_time).format("HH:mm")}</td>
                                                                                        <td className="bold align-middle">{c.class_name}</td>
                                                                                        <td className="level-slots-td align-middle">
                                                                                            <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
                                                                                            <span className="d-none d-lg-inline">{c.class_level_name}</span>
                                                                                            <span className="d-lg-none">
                                                                                                {c.class_level_name === "Ponadpodstawowy"
                                                                                                    ? "Ponadpodst."
                                                                                                    : c.class_level_name === "Średniozaawansowany"
                                                                                                      ? " Średniozaaw."
                                                                                                      : c.class_level_name === "Zaawansowany"
                                                                                                        ? "Zaawans."
                                                                                                        : c.class_level_name === "Początkujący"
                                                                                                          ? "Począt."
                                                                                                          : c.class_level_name}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td rowSpan={2} className="text-end align-middle action-btns">
                                                                                            {showView && location.pathname !== "/" ? (
                                                                                                <ActionBtns
                                                                                                    permissions={permissions}
                                                                                                    c={c}
                                                                                                    j={j}
                                                                                                    getSchedule={getSchedule}
                                                                                                    filterDates={filterDates}
                                                                                                    setLoading={setLoading}
                                                                                                    reloadData={() => {
                                                                                                        setLoading(true);
                                                                                                        setTimeout(() => {
                                                                                                            getSchedule(filterDates.startDate, filterDates.endDate);
                                                                                                        }, 150);
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <Button
                                                                                                    variant="outline-secondary"
                                                                                                    className={`btn-class btn-outline-${c.class_level_colour}`}
                                                                                                    onClick={() => setShowClassDetailsModal(c)}
                                                                                                >
                                                                                                    {t("more")}
                                                                                                </Button>
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr
                                                                                        className={`${
                                                                                            c.class_status_code === "CANCELLED" && "class-cancelled"
                                                                                        } hour-td class-lvl-bg-${c.class_level_colour ? c.class_level_colour : "white"}`}
                                                                                    >
                                                                                        <td className="bold">{moment(c.class_end_time).format("HH:mm")}</td>
                                                                                        <td className="align-middle">
                                                                                            {c.instructor_label ? (
                                                                                                <SubstituteInstructor i={i} c={c} />
                                                                                            ) : (
                                                                                                `${c.instructor_name} ${c.instructor_surname}`
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            <FontAwesomeIcon icon={faUsers} className="me-2" />
                                                                                            <span
                                                                                                className={
                                                                                                    c.class_slots - c.free_slots + c.cnt_waitlist > c.class_slots ? "bold" : ""
                                                                                                }
                                                                                            >
                                                                                                {c.class_slots - c.free_slots + c.cnt_waitlist}/{c.class_slots}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                    {j < e.classes.length - 1 && (
                                                                                        <tr className={`${c.class_status_code === "CANCELLED" && "class-cancelled"}`}>
                                                                                            <td colSpan={4} className="p-0" style={{ height: "2px" }}></td>
                                                                                        </tr>
                                                                                    )}
                                                                                </Fragment>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        ))}
                                    </Col>
                                )}
                            </Fragment>
                        )}
                    </Row>
                </Container>
            )}
            {showClassDetailsModal && (
                <SimpleTextModal
                    title={`${t("schedule.classDetails")} ${showClassDetailsModal.class_name}`}
                    onClose={() => setShowClassDetailsModal(false)}
                    txt={showClassDetailsModal.class_descr}
                    show={true}
                />
            )}
        </Fragment>
    );
};

export default Schedule;
